export const JOB_STATUSES = {
	OPEN: 'open',
	CLOSED: 'closed',
};
